import Barnav from './barnav'

export default Barnav